// ============================================================
// 1. src/utils/errorUtils.js (NEW - 공통 에러 유틸)
// ============================================================

/**
 * 에러 메시지 추출 (공통 유틸)
 * - Axios 에러, 커스텀 에러, 일반 Error 모두 처리
 */
export function extractErrorMessage(error) {
  if (!error) return '';

  try {
    // Axios 에러
    if (error.response?.data) {
      const data = error.response.data;
      return data.message || data.error || data.msg || '';
    }

    // 커스텀 에러 응답 (errorResponse)
    if (error.errorResponse?.message) {
      return error.errorResponse.message;
    }

    // 일반 Error
    if (error.message) {
      return error.message;
    }

    // 문자열
    if (typeof error === 'string') {
      return error;
    }

    return '';
  } catch {
    return '';
  }
}

/**
 * HTTP 상태 코드에 따른 에러 타입 분류
 */
export function classifyError(error) {
  const status = error?.response?.status;
  
  return {
    status,
    isNetworkError: !error?.response && !!error,
    isClientError: status >= 400 && status < 500,
    isServerError: status >= 500,
    isAuthError: status === 401 || status === 403,
    isNotFound: status === 404,
    isValidationError: status === 400 || status === 422,
  };
}
